import { KnockoutStage } from "../types/TournamentMatch";

export interface StagePoints {
  /** Right outcome (correct winner/draw, wrong score). */
  outcome: number;
  /** Perfect score (exact result). */
  exact: number;
}

// Per-round reward, mirroring the backend TyperScore enum
// (Analysis/Models/Enums/TyperScore.cs). Knockout points scale up each round;
// the third-place play-off is weighted as a semifinal peer.
export const KNOCKOUT_STAGE_POINTS: Record<KnockoutStage, StagePoints> = {
  "Round of 32": { outcome: 3, exact: 6 },
  "Round of 16": { outcome: 4, exact: 8 },
  "Quarter-finals": { outcome: 5, exact: 10 },
  "Semi-finals": { outcome: 6, exact: 12 },
  "Play-off for third place": { outcome: 6, exact: 12 },
  Final: { outcome: 7, exact: 14 },
};

export function getStagePoints(stage: KnockoutStage): StagePoints {
  return KNOCKOUT_STAGE_POINTS[stage];
}
